
import { Subscription } from "@/types/subscription";
import { getLocalSubscriptions, saveLocalSubscriptions } from "./localStorageUtils";

export const calculatePaymentsDue = (subscriptions: Subscription[]): Subscription[] => {
  const today = new Date();
  
  return subscriptions.map((sub) => {
    const startDate = new Date(sub.startDate);
    const binDay = sub.binDay.toLowerCase();
    const dayIndex = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].indexOf(binDay);
    
    if (dayIndex >= 0) {
      let firstBinDay = new Date(startDate);
      const daysAhead = (dayIndex - startDate.getDay() + 7) % 7;
      firstBinDay.setDate(startDate.getDate() + daysAhead);
      
      if (firstBinDay <= today) {
        const daysBetween = Math.floor((today.getTime() - firstBinDay.getTime()) / (24 * 60 * 60 * 1000));
        const weeksElapsed = Math.floor(daysBetween / 7) + 1;
        
        // Determine rate based on business vs residential
        const weeklyRate = sub.isBusiness ? 20 : 5;
        const annualRate = sub.isBusiness ? 840 : 210;
        
        // Use the appropriate rate
        const totalOwed = sub.isAnnual ? annualRate : (weeksElapsed * weeklyRate);
        const amountDue = totalOwed - sub.totalPaid;
        
        if (amountDue > 0) {
          return {
            ...sub,
            totalPaid: sub.totalPaid + amountDue
          };
        }
      }
    }
    return sub;
  });
};
